module.exports = __webpack_public_path__ + "img/discovery.a07d1ac8.jpg";